<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>

<p-toast position="center"></p-toast>
<!-- / -->
<main class="w-full px-4">
  <div class="mx-auto max-w-7xl">
    <ng-container *ngIf="product?.id; else loading">
      <div [innerHTML]="product_schema | jsonLd"></div>

      <!-- Breadcrumbs -->
      <nav class="flex mt-12" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div>
              <a [routerLink]="['/']" class="text-gray-400 hover:text-pink-800">
                <svg class="h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Início</span>
              </a>
            </div>
          </li>

          <li>
            <div class="flex items-center">
              <svg class="h-5 w-5 flex-shrink-0 text-pink-800" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <p class="ml-4 text-sm font-medium text-gray-500 hover:text-pink-800" aria-current="page">{{product.name}}</p>
            </div>
          </li>
        </ol>
      </nav>

      <div class="bottom-24 right-0 fixed z-20">
        <ng-container *ngIf="cart?.client_marketplace_cart_uid">
          <IncluceProductBuyInline [cart]="cart" [product]="product"></IncluceProductBuyInline>
        </ng-container>
      </div>

      <!-- Product -->
      <div class="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 pt-12">
        <!-- Image gallery -->
        <div class="flex flex-col-reverse sm:flex-row sm:space-x-6">
          <!-- Image selector -->
          <div class="mx-auto hidden max-w-2xl sm:block lg:w-1/4">
            <div class="grid grid-rows-4 gap-y-3" aria-orientation="vertical" role="tablist">
              <ng-container *ngIf="images?.data.length > 0">
                <ng-container *ngFor="let image of images?.data; else loadingImageSelector">
                  <button id="tabs-2-tab-1" class="relative flex h-24 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium uppercase text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring focus:ring-amber-300 focus:ring-opacity-50 focus:ring-offset-4" aria-controls="tabs-2-panel-1" role="tab" type="button">
                    <span class="sr-only"> {{product.name}} </span>
                    <span class="absolute inset-0 overflow-hidden rounded-md">
                      <img (click)="changeImageView(image)" src="{{image.url_size_576}}" alt="{{product.name}}" class="h-full w-full object-cover object-center border border-gray-200" />
                    </span>
                    <!-- Selected: "ring-indigo-500", Not Selected: "ring-transparent" -->
                    <span class="ring-transparent selection:ring-amber-300 pointer-events-none absolute inset-0 rounded-md ring-2 ring-offset-2" aria-hidden="true"></span>
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <div class="w-full">
            <!-- Tab panel, show/hide based on tab state. -->
            <div id="tabs-2-panel-1" aria-labelledby="tabs-2-tab-1" role="tabpanel" tabindex="0">
              <ng-container *ngIf="images?.data.length > 0; else loadingImage">
                <img src="{{currentImage}}" alt="{{product.name}}" class="w-full h-full object-contain object-center sm:rounded-lg border border-gray-200" />
              </ng-container>
              <ng-container *ngIf="images?.data == ''">
                <img src="/assets/images/no_imagem.png" alt="{{product.name}}" class="h-full w-full object-contain object-center sm:rounded-lg border border-gray-200" />
              </ng-container>
            </div>

            <!-- More images... -->
          </div>
        </div>

        <!-- Product info -->
        <div class="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
          <div class="flex justify-between items-center">
            <!-- Reviews -->
            <div class="mb-3">
              <ng-container *ngIf="product.stars > 0">
                <h3 class="sr-only">Avaliações</h3>
                <div class="flex items-center">
                  <div class="flex items-center space-x-2">
                    <img class="w-16" src="/assets/images/star{{product.stars}}.png" alt="{{product.stars}} Estrelas de Avaliação" />
                    <button (click)="scrollToReviews()" class="text-gray-600 text-xs font-medium underline cursor-pointer">({{product.reviews.length}} avaliações)</button>
                  </div>
                  <p class="sr-only">{{product.stars}} de 5 estrelas</p>
                </div>
              </ng-container>
            </div>
            <button title="Adicionar aos Favoritos" (click)="clientMarketplaceWishlistProductServiceCreate(product.id)">
              <ng-container *ngIf="clientMarketplacePreferenceFavoriteServiceExists(product); else notCustomerFavorite">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 stroke-transparent text-pink-800">
                  <path
                    d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z"
                  />
                </svg>
              </ng-container>
              <ng-template #notCustomerFavorite>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 stroke-gray-600">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                </svg>
              </ng-template>
            </button>
          </div>

          <h1 class="text-3xl font-semibold tracking-tight text-gray-700">{{product.name}}</h1>

          <p class="text-gray-500 text-xs pt-1 font-light">(Cód. Item {{product.id}})</p>

          <div class="my-4">
            <h2 class="sr-only">Informações</h2>
            <ng-container *ngIf="product.price_discount_percent != null">
              <ng-container *ngIf="product.price_compare_at > 0">
                <p class="text-xs text-gray-600 lg:text-sm font-light"><span class="line-through">R$ {{product.price_compare_at | number:'1.2-2'}}</span></p>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="product.price > 0">
              <div class="flex items-start space-x-2.5">
                <p class="text-pink-800 font-bold text-3xl">R$ {{product.price | number:'1.2-2'}}</p>
                <span *ngIf="product.price_discount_percent != null" class="bg-[#FFBE0B] rounded-md p-1.5 text-sm font-semibold text-black">{{product.price_discount_percent | number:'1.0-0'}}%</span>
              </div>
              <ng-container *ngIf="product.price_installment_no_fee > 0">
                <div class="space-y-1 py-1">
                  <p class="text-xs text-gray-700 lg:text-sm font-light">em <span class="font-medium">{{product.installment_no_fee}}x</span> de <span class="font-medium">{{product.price_installment_no_fee | number:'1.2-2'}}</span> sem juros*</p>
                </div>
              </ng-container>
              <ng-container *ngIf="marketplace?.payment?.discount_percent_boleto">
                <ng-container *ngIf="marketplace?.payment?.discount_percent_boleto > 0">
                  <div class="flex items-center space-x-2 pt-2.5">
                    <svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15.273 15.273" xml:space="preserve" fill="#000000">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          <path
                            style="fill: #9d174d"
                            d="M0,1.803h0.897V13.47H0V1.803z M1.446,13.47h0.505V1.803H1.446V13.47z M2.315,13.47h0.504V1.803 H2.315V13.47z M3.482,13.47h1.104V1.803H3.482V13.47z M5.47,13.47h0.552V1.803H5.47V13.47z M6.878,13.47h2.288V1.803H6.878V13.47z M12.84,13.47h0.752V1.803H12.84V13.47z M14.248,1.803V13.47h1.025V1.803H14.248z M10.084,13.47h0.492V1.803h-0.492V13.47z M11.281,13.47h0.492V1.803h-0.492V13.47z"
                          ></path>
                        </g>
                      </g>
                    </svg>
                    <p class="text-xs text-gray-700 lg:text-sm font-light">
                      <span class="font-medium">{{marketplace?.payment?.discount_percent_boleto}}% de desconto</span> via
                      <span class="font-medium">Boleto Bancário</span>
                    </p>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>

          <ng-container *ngIf="product.product_type == 'kit'">
            <ng-container *ngIf="product.kit_price_discount > 0">
              <div class="rounded-lg bg-green-100 p-2 w-full lg:w-1/2">
                <p class="font-bold text-xs uppercase text-green-800 lg:text-[.75rem]">Alerta de economia</p>
                <p class="text-xs text-green-900 lg:text-[.7rem]">Você economiza <strong>R$ {{product.kit_price_discount | number:'1.2-2'}}</strong>, comprando esse KIT, ao invés dos produtos separados.</p>
              </div>
            </ng-container>
          </ng-container>

          <div class="py-3.5">
            <div class="flex flex-col">
              <ng-container *ngIf="cart?.client_marketplace_cart_uid">
                <IncluceProductBuy [cart]="cart" [product]="product"></IncluceProductBuy>
              </ng-container>

              <div class="pt-8 w-full">
                <div class="bg-gray-100 p-4 flex flex-col items-start sm:flex-row sm:items-center justify-between rounded-t-md">
                  <p class="text-pink-800 font-semibold text-sm py-2 sm:text-base">Calcule o frete e prazo de entrega</p>
                  <div class="flex items-center space-x-4">
                    <p-inputMask placeholder="Digite seu CEP" name="shopping.zipcode" [(ngModel)]="shopping.zipcode" #shopping.zipcode="ngModel" mask="99999-999" class="p-inputtext-sm" [styleClass]="'focus:outline-none border-2 border-gray-200 bg-white rounded-lg placeholder-gray-400'"></p-inputMask>
                    <button (click)="clientMarketplaceCoreProductServicePriceDelivery();" title="Calcular Frete" class="bg-pink-800 rounded-lg hover:bg-pink-900 px-3.5 py-3 text-white text-xs lg:text-sm font-medium">Calcular</button>
                  </div>
                </div>
                <!-- cep -->
                <div *ngIf="price_delivery?.shippingServices" class="bg-[#fafafa] rounded-b-md p-3">
                  <div class="flex flex-col space-y-4 justify-start px-4 divide-y">
                    <ng-container *ngFor="let delivery of price_delivery.shippingServices">
                      <div class="flex items-center justify-between pt-3">
                        <div class="flex flex-col">
                          <p class="text-gray-800 text-sm">{{delivery.name}}</p>
                          <p class="text-gray-800 text-sm font-medium">Receba em até {{delivery.days}} dias úteis</p>
                        </div>
                        <p class="font-medium text-sm text-gray-800">R$ {{delivery.price | number:'1.2-2'}}</p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <!-- garantia -->
              <div class="pt-8 w-full" id="sright_product_box">
                <span class="sr-only">Garantias {{marketplace?.name}}</span>
                <div class="flex items-start space-x-6 border border-gray-100 p-5 rounded-md">
                  <div class="flex flex-col items-start space-y-1.5 w-48">
                    <div class="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5 stroke-pink-800">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                      </svg>
                      <p class="text-sm font-semibold text-pink-800">Devolução grátis</p>
                    </div>
                    <p class="text-xs text-gray-700 pt-1">Você tem 7 dias a partir da data de recebimento.</p>
                  </div>

                  <div class="flex flex-col items-start space-x-2 space-y-1.5 w-48">
                    <div class="flex items-center space-x-2">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5 stroke-pink-800">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                      </svg>
                      <p class="text-sm font-semibold text-pink-800">Compra Garantida</p>
                    </div>
                    <p class="text-xs text-gray-700 pt-1">Receba o produto que está esperando ou devolvemos o dinheiro.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section aria-labelledby="details-heading" class="py-16">
        <div>
          <!-- Expand/collapse question button -->
          <button (click)="expandDetails()" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50" aria-controls="disclosure-1" aria-expanded="false">
            <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
            <span class="text-gray-900 text-sm font-medium">Descrição do Produto</span>
            <span class="ml-6 flex items-center">
              <!-- Open: "hidden", Closed: "block" -->
              <svg id="expand-disclosure-1" (click)="showProductDescription('disclosure-1', 'expand-disclosure-1', 'collapse-disclosure-1')" class="hidden h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg>
              <!-- Open: "block", Closed: "hidden" -->
              <svg id="collapse-disclosure-1" (click)="showProductDescription('disclosure-1', 'expand-disclosure-1', 'collapse-disclosure-1')" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
              </svg>
            </span>
          </button>
          <div class="p-4 block w-full border border-lg rounded-b-md" id="disclosure-1">
            <ng-container *ngIf="product.body_description_start !== ''">
              <div class="text-sm w-full" [innerHTML]="product.body_description_start | html"></div>
            </ng-container>
            <ng-container *ngIf="product.body_description_short !== ''">
              <div class="text-sm" [innerHTML]="product.body_description_short | html"></div>
            </ng-container>
            <ng-container *ngIf="product.body_description_large !== ''">
              <div class="text-sm" [innerHTML]="product.body_description_large | html"></div>
            </ng-container>
          </div>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 pt-4">
          <ng-container *ngIf="product.body_description_benefit !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Vantagens', product.body_description_benefit)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Vantagens</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-3" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_specifics !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Características', product.body_description_specifics)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Características</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-4" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_technical_detail !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Detalhes Técnicos', product.body_description_technical_detail)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Detalhes Técnicos</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-5" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_content !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Conteúdo da Embalagem', product.body_description_content)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Conteúdo da Embalagem</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-6" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_composition !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Composição', product.body_description_composition)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Composição</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-7" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_how_to !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Modo de Usar', product.body_description_how_to)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Modo de Usar</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-8" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.body_description_tip !== ''">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Dicas de Uso', product.body_description_tip)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Dicas de Uso</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-9" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="product.ia_chat_gpt.length > 0">
            <div>
              <!-- Expand/collapse question button -->
              <button (click)="showSelectedDescription('Perguntas Frequentes', product.ia_chat_gpt)" type="button" class="group relative flex w-full items-center justify-between p-4 text-left bg-gray-50 hover:bg-gray-100" aria-controls="disclosure-1" aria-expanded="false">
                <!-- Open: "text-indigo-600", Closed: "text-gray-900" -->
                <span class="text-gray-900 text-sm font-medium">Perguntas Frequentes</span>
                <span class="ml-6 flex items-center">
                  <!-- Open: "hidden", Closed: "block" -->
                  <svg id="expand-disclosure-10" class="block h-6 w-6 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                  </svg>
                </span>
              </button>
            </div>
          </ng-container>
        </div>
      </section>

      <ng-container *ngIf="product.url_video != ''">
        <div class="aspect-w-16 aspect-h-9 border border-gray-300 shadow-md">
          <iframe [src]="product.url_video | safe: 'resourceUrl'" title="{{product.name}}" aria-label="{{product.name}}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </ng-container>

      <ng-container *ngIf="product.stars > 0">
        <section id="reviews" aria-labelledby="related-heading" class="my-10 border-t border-gray-200 py-6 px-4 sm:px-0">
          <div class="mx-auto max-w-2xl py-24 lg:grid lg:max-w-7xl lg:grid-cols-12 lg:gap-x-8">
            <div class="lg:col-span-4">
              <h2 id="reviews-heading" class="text-2xl font-bold tracking-tight text-gray-900">Avaliações de clientes</h2>

              <div class="mt-3 flex items-center">
                <div>
                  <img class="w-24" src="/assets/images/star{{product.stars}}.png" />
                  <p class="sr-only">{{product.starts}} de 5 estrelas</p>
                </div>
                <p class="ml-2 text-sm text-gray-900">Baseado em {{product.reviews.length}} avaliações</p>
              </div>
            </div>

            <div class="mt-16 lg:col-span-7 lg:col-start-6 lg:mt-0">
              <h3 class="sr-only">Avaliações</h3>

              <div class="flow-root">
                <div class="-my-12 divide-y divide-gray-200">
                  <ng-container *ngFor="let review of product.reviews">
                    <div class="py-12">
                      <div class="flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8 text-amber-400">
                          <path
                            fill-rule="evenodd"
                            d="M18.685 19.097A9.723 9.723 0 0021.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 003.065 7.097A9.716 9.716 0 0012 21.75a9.716 9.716 0 006.685-2.653zm-12.54-1.285A7.486 7.486 0 0112 15a7.486 7.486 0 015.855 2.812A8.224 8.224 0 0112 20.25a8.224 8.224 0 01-5.855-2.438zM15.75 9a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div class="ml-4">
                          <h4 class="text-sm font-bold text-gray-900">{{review.name}}</h4>
                          <div class="mt-1 flex items-center">
                            <!-- Active: "text-yellow-400", Default: "text-gray-300" -->
                            <img src="/assets/images/star{{review.stars}}.png" class="w-20" />
                          </div>
                          <p class="sr-only">{{review.stars}} de 5 estrelas</p>
                        </div>
                      </div>

                      <div class="mt-4 space-y-6 text-base italic text-gray-600">
                        <p>{{review.description}}</p>
                      </div>
                    </div>
                  </ng-container>

                  <!-- More reviews... -->
                </div>
              </div>
            </div>
          </div>
        </section>
      </ng-container>

      <ng-container *ngIf="relProducts?.length > 0">
        <section aria-labelledby="related-heading" class="my-10 border-t border-gray-200 py-16 px-4 sm:px-0">
          <h2 id="related-heading" class="text-2xl font-bold text-pink-800">Produtos relacionados a este item</h2>

          <ng-container *ngIf="cart?.client_marketplace_cart_uid">
            <div class="pt-6">
              <div class="w-full overflow-x-auto">
                <div class="inline-flex space-x-6">
                  <ng-container *ngFor="let relProduct of relProducts;">
                    <IncludeProductContainer [cart]="cart" [product]="relProduct.product"></IncludeProductContainer>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </section>
      </ng-container>
    </ng-container>
  </div>
</main>

<p-dialog header="{{actualDescription.name}}" [(visible)]="showDescription" [modal]="true" [style]="{width: '50vw'}" [dismissableMask]="true">
  <ng-container *ngIf="actualDescription.name !== 'Perguntas Frequentes'">
    <p class="text-sm" [innerHTML]="actualDescription.description  | html"></p>
  </ng-container>
  <ng-container *ngIf="actualDescription.name == 'Perguntas Frequentes'">
    <ng-container *ngFor="let ia of actualDescription.description;">
      <div class="pb-2">
        <span class="text-gray-900 text-sm font-medium">{{ia.question_friendly}}</span>
        <p class="text-sm" [innerHTML]="ia.content  | html"></p>
      </div>
    </ng-container>
  </ng-container>
</p-dialog>

<ng-template #loading>
  <div class="my-10">
    <nav aria-label="Breadcrumb">
      <ol role="list" class="flex items-center space-x-4">
        <li>
          <div role="status" class="max-w-sm animate-pulse">
            <div class="bg-gray-200 rounded w-48 h-3 mb-4"></div>
          </div>
        </li>
      </ol>
    </nav>

    <!-- Product -->
    <div class="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 pt-12">
      <!-- Image gallery -->
      <div class="flex flex-col-reverse sm:flex-row sm:space-x-6">
        <!-- Image selector -->
        <div class="mx-auto hidden max-w-2xl sm:block lg:w-1/4">
          <div class="grid grid-rows-4 gap-y-3" aria-orientation="vertical" role="tablist">
            <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
              <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-24"></div>
            </div>
            <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
              <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-24"></div>
            </div>
          </div>
        </div>
        <div class="w-full">
          <!-- Tab panel, show/hide based on tab state. -->
          <div id="tabs-2-panel-1" aria-labelledby="tabs-2-tab-1" role="tabpanel" tabindex="0">
            <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
              <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-96"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Product info -->
      <div class="mt-10 sm:mt-16 sm:px-0 lg:mt-0 flex flex-col space-y-4">
        <div>
          <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
            <div class="flex items-center justify-center w-full h-8 bg-gray-300 rounded"></div>
          </div>
        </div>

        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
          <div class="flex items-center justify-center w-full h-44 bg-gray-300 rounded"></div>
        </div>

        <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
          <div class="flex items-center justify-center w-full h-36 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingImage>
  <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
    <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full"></div>
  </div>
</ng-template>

<ng-template #loadingImageSelector>
  <div class="grid grid-rows-4 gap-y-3" aria-orientation="vertical" role="tablist">
    <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
      <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-24"></div>
    </div>
    <div role="status" class="space-y-8 animate-pulse md:space-y-0 md:space-x-8 md:flex md:items-center">
      <div class="flex items-center justify-center w-full h-48 bg-gray-300 rounded sm:w-full sm:h-24"></div>
    </div>
  </div>
</ng-template>
